import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const PART_WARRANTIES_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('PART_WARRANTIES');
export const PART_WARRANTIES_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	PART_WARRANTIES_CRUD_ACTION_CONSTANTS
);
